import { FC } from 'react';

import LightTwoColsHeader from '~src/shared/headers/lightTwoColsHeader/LightTwoColsHeader';

const Header: FC = () => {
  return (
    <>
      <LightTwoColsHeader
        title={{ key: 'x.analysis.spider-web.header.title' }}
        descr={{ key: 'x.analysis.spider-web.header.description' }}
      />
    </>
  );
};

export default Header;
